import React, { Component } from 'react'
import { connect } from 'react-redux'
import classes from './MarksFilters.module.scss';

import { Tooltip } from 'react-tippy';

import { loadFilters, setSelectedFilters, setType, resetSelectedFilters, setLetter, deleteSelectedFilters } from '../../../redux/marks/actions';

import { FilterButton } from '../../../common/index';
import 'react-tippy/dist/tippy.css'

import Select from 'react-select'

import _ from 'lodash';
import { classExpression } from '@babel/types';

const customStyles = {
    input: () => ({ margin:0, padding:0 }),
    control: (provided) => ({  ...provided, minHeight:36 }),
}


class MarksFilters extends Component {

    componentDidMount(){
        this.props.loadFilters();
    }

    handleChangeType = (type) => {
        this.props.setType(type)
     };

    handleSelectChange = (filtername, newValue) => {
       this.props.setSelectedFilters(filtername, newValue)
    };
    handleLetterChange = (value) => {
        this.props.setLetter(value)
     };

     handleDelete = (filter) => {
       this.props.deleteSelectedFilters(filter);
     };

     handleSearchChange = (value) => {
        this.props.setSelectedFilters('search', {value:0, label:value} )
     };

    render() {
        let filterstodisplay = [];
        _.mapKeys(this.props.selectedfilters, (value, key)=>{
            if(_.isArray(value) && key!=='letters'){
                value.map((valuetofilter) => {
                    if(valuetofilter){
                        filterstodisplay.push({
                            ...valuetofilter,
                            filtername:key
                        });
                    }
                });
            }else{
                if(value && key!=='letters'){
                    filterstodisplay.push({
                        ...value,
                        filtername:key
                    });
                }
            }
        });
        const lettersArray = [...this.props.selectedfilters.letters];
        if(lettersArray && lettersArray.length>0){
            lettersArray.map((letter, letterindex)=>{
                if(letter){        
                    filterstodisplay.push({
                        value:letterindex,
                        label: letter,
                        filtername:'letters'
                    });
                }
            });
        }

        return(
            <div className={classes.Container}>
            { filterstodisplay && filterstodisplay.length>0 ?<div className={classes.FiltersList}>
                { filterstodisplay.map((filter)=>
                    (<FilterButton key={`${filter.filtername}_${filter.value}`} onDelete={()=>this.handleDelete(filter)} title={filter.label}></FilterButton>)
                )}
                <div><button className={classes.reset} onClick={this.props.resetSelectedFilters}>Reset filters</button></div>
            </div>:null }
            <div className={classes.Mainfilters}>
            <button  className={this.props.type==="all" ? classes.active:null} onClick={()=>this.handleChangeType("all")}>All</button>
            <button  className={this.props.type==="makers" ? classes.active:null} onClick={()=>this.handleChangeType("makers")}>Maker's Marks</button>
            { this.props.type==="makers" ? <Select styles={customStyles} options={ this.props.filters.makers} onChange={ (newValue) => this.handleSelectChange('makers', newValue) } isSearchable isClearable  /> : null }
            <button className={this.props.type==="assay" ? classes.active:null} onClick={()=>this.handleChangeType("assay")}>Assay Marks</button>
            { this.props.type==="assay" ? <Select styles={customStyles} options={ this.props.filters.metals} onChange={ (newValue) => this.handleSelectChange('metals', newValue) } isSearchable isClearable /> : null }
            <button  className={this.props.type==="others" ? classes.active:null} onClick={()=>this.handleChangeType("others")}>Other Marks</button>
            <button  className={this.props.type==="favorite" ? classes.active:null} onClick={()=>this.handleChangeType("favorite")}>Favorites</button>
            </div>
            <div>
            <label>Outer shape</label>
            <Select styles={customStyles} options={ this.props.filters.shapes} value={ this.props.selectedfilters.shapes } onChange={ (newValue) => this.handleSelectChange('shapes', newValue) } isSearchable isClearable />
            </div>
            <div>
            <label>Symbol <Tooltip title={this.props.termes.application.membreTootltipMarksSymbol}><img src={ require('../../../assets/img/tooltip.svg')} /></Tooltip></label>
            <Select styles={customStyles} options={ this.props.filters.symbols} value={ this.props.selectedfilters.symbols }  onChange={ (newValue) => this.handleSelectChange('symbols', newValue) } isSearchable isClearable isMulti />
            </div>
            <div>
            <label>Letters / Numbers <Tooltip title={this.props.termes.application.membreTootltipMarksLetters}><img src={ require('../../../assets/img/tooltip.svg')} /></Tooltip></label>
            <input onChange={ (event) => this.handleLetterChange(event.target.value) } value={ this.props.selectedfilters.letters } type="text" autoComplete="off" />
            </div>
            <div>
            <label>Countries</label>
            <Select styles={customStyles} options={ this.props.filters.countries}  value={ this.props.selectedfilters.countries }  onChange={ (newValue) => this.handleSelectChange('countries', newValue) } isSearchable isClearable  />
            </div>
            <div>
            <label>Cities</label>
            <Select styles={customStyles} options={ this.props.filters.cities}  value={ this.props.selectedfilters.cities }  onChange={ (newValue) => this.handleSelectChange('cities', newValue) } isSearchable isClearable  />
            </div>
            <div>
            <label>Search <Tooltip title={this.props.termes.application.membreTootltipMarksSearch}><img src={ require('../../../assets/img/tooltip.svg')} /></Tooltip></label>
            <input onChange={ (event) => this.handleSearchChange(event.target.value) } value={ this.props.selectedfilters.search ? this.props.selectedfilters.search.label:'' } type="text" autoComplete="off" />
            </div>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      filters: state.marks.filters,
      type: state.marks.type,
      selectedfilters: state.marks.selectedfilters,
      termes: state.settings.termes
    }
  };

export default connect(mapStateToProps, { loadFilters, setSelectedFilters, setType, resetSelectedFilters, setLetter, deleteSelectedFilters})(MarksFilters);
